import { render, staticRenderFns } from "./WsInfiniteScrollWrap002.vue?vue&type=template&id=22790472&"
import script from "./WsInfiniteScrollWrap002.vue?vue&type=script&lang=js&"
export * from "./WsInfiniteScrollWrap002.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports